
<!-- Floating Action Button que controla la visibilidad del chatbot -->
<button id="chatbot-toggle" (click)="toggleChatbot()">
    <i class="chatboticon ri-chat-smile-3-line"></i>
</button>

<div class="chatbot-container" *ngIf="!chatbotVisible">
    <div class="chatbot-header">
        Chatbot
    </div>
    <div class="chatbot-body">
        <!-- Mensajes del chat -->
        <div *ngFor="let message of messages" class="chat-message" [ngClass]="{'user-message': message.role === 'user', 'bot-message': message.role === 'assistant'}">
            {{ message.content }}
        </div>
        <div class="chat-message bot-message" align="center" *ngIf="loadChat">
            <div class="spinner-grow text-light load-circle" role="status">
                <span class="sr-only">Loading...</span>
            </div>
            <div class="spinner-grow text-light load-circle" role="status">
                <span class="sr-only">Loading...</span>
            </div>
            <div class="spinner-grow text-light load-circle" role="status">
                <span class="sr-only">Loading...</span>
            </div>
        </div>
    </div>
    <div class="chatbot-input">
        <input type="text" [(ngModel)]="userInput" placeholder="Escribe tu mensaje aquí..." (keyup.enter)="sendMessage()">
        <button (click)="sendMessage()">Send</button>
    </div>
</div>
